const getters = {
  // showList: state => state.app.showList,
  token: state => state.app.token,
  // avatar: state => state.user.avatar,
  user: state => state.app.user,
  status: state => state.app.status,
  name: state => state.app.name,
  cartCount: state => state.app.cartCount,
  activeColor: state => state.app.activeColor,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js